import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[xpo-prevent-characters]',
})
export class XpoPreventCharactersDirective {
  constructor() {}
  @Input('xpo-prevent-characters') xpoPreventCharacters: string[];

  @HostListener('keydown', ['$event'])
  handleClickEvent(event) {
    return !this.xpoPreventCharacters.some((char) => char === event.key);
  }
}
